module.exports = __webpack_public_path__ + "img/clipboard.35dea81d.svg";